import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { DeleteAssessmentBase } from "../DeleteAssessmentBase";

/**
 * Delete a Training Module assessment.
 */
export const DeleteTrainingModule = () => (<DeleteAssessmentBase defaultAssessmentType={AssessmentType.TrainingModule} />);
